var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState, useContext, useEffect, useCallback } from "react";
import { Link } from "react-router-dom";
import PublicTemplate from "../../../../components/templates/PublicTemplate";
import Loader from "../../../../components/Loader";
import { BreadcrumbContext } from "../../../../components/Breadcrumb";
import { AuthContext } from "../../../../components/FirebaseAuth";
import { CloudFunctions } from "../../../../components/FirebaseAuth/firebase";
import { FirebaseAuth } from "../../../../components/FirebaseAuth/firebase";
import Alert from "../../../../components/Alert";
import Modal from 'react-bootstrap/Modal';
import EditRegistration from "../EditRegistration";
import EditRegistrationConsumer from "../EditRegistrationConsumer";
import Highlight from "react-highlight";
import CopyableElement from "../../../../components/CopyableElement";
import DataTable, { defaultThemes } from 'react-data-table-component';
import { Button } from "react-bootstrap";
import AccountSteps from "../../../../components/AccountSteps";
import { Input } from "../../../../components/Form";
;
var Registrations = function () {
    var _a, _b, _c, _d, _e;
    var title = "Registrations";
    var userData = useContext(AuthContext).userData;
    var setBreadcrumb = useContext(BreadcrumbContext).setBreadcrumb;
    var _f = useState(null), settingsComplete = _f[0], setSettingsComplete = _f[1];
    var _g = useState(null), subdomain = _g[0], setSubdomain = _g[1];
    var _h = useState(null), registrations = _h[0], setRegistrations = _h[1];
    var _j = useState(null), errorMessage = _j[0], setErrorMessage = _j[1];
    var _k = useState(null), helpMessage = _k[0], setHelpMessage = _k[1];
    var _l = useState(true), loading = _l[0], setLoading = _l[1];
    var _m = useState(false), saving = _m[0], setSaving = _m[1];
    var _o = useState("provider"), accountType = _o[0], setAccountType = _o[1];
    var _p = useState(false), hasDynamicRegistration = _p[0], setHasDynamicRegistration = _p[1];
    var _q = useState(true), accountFirebase = _q[0], setAccountFirebase = _q[1];
    var _r = useState({
        visible: false,
        row: undefined,
    }), showChangeActivationDialog = _r[0], setShowChangeActivationDialog = _r[1];
    var _s = useState({
        visible: false,
        row: undefined,
    }), deleteDialog = _s[0], setDeleteDialog = _s[1];
    var _t = useState("Register Platform"), registrationTitle = _t[0], setRegistrationTitle = _t[1];
    var _u = useState(false), registrationFormVisible = _u[0], setRegistrationFormVisible = _u[1];
    var _v = useState(false), registrationURLsVisible = _v[0], setRegistrationURLsVisible = _v[1];
    var _w = useState(null), registrationInfo = _w[0], setRegistrationInfo = _w[1];
    var _x = useState(false), showDeleteButton = _x[0], setShowDeleteButton = _x[1];
    var _y = useState(null), successMessage = _y[0], setSuccessMessage = _y[1];
    var _z = useState(false), guide = _z[0], setGuide = _z[1];
    // get 'guide' query parameter
    useEffect(function () {
        var urlParams = new URLSearchParams(window.location.search);
        var guideParam = urlParams.get("guide");
        setGuide(guideParam === "true");
    }, []);
    //TODO: Add filtering https://react-data-table-component.netlify.app/?path=/story/examples-filtering--filtering
    function ActiveSelect(data) {
        return _jsx(Button, { disabled: saving, variant: data.row.active ? "success" : "danger", onClick: function () { return setShowChangeActivationDialog({ visible: true, row: data.row }); }, children: data.row.active ? "true" : "false" });
    }
    function EditButton(data) {
        return _jsx(Button, { onClick: function () {
                setDeleteDialog({ visible: true, row: data.row });
                var info = JSON.stringify(data.row, null, 2);
                //console.log(info);
                var replaced = info.replaceAll('\\n', '\n');
                setRegistrationInfo(replaced);
            }, children: _jsx("i", { className: "fa fa-edit" }) });
    }
    var columns = [
        {
            name: 'Edit',
            button: true,
            cell: function (row) { return _jsx(EditButton, { row: row }); },
            sortable: true,
        },
        {
            name: 'id',
            selector: function (row) { return row.id || ""; },
            sortable: true,
        },
        {
            name: 'clientId',
            selector: function (row) { return row.clientId; },
            sortable: true,
        },
        {
            name: 'Name',
            selector: function (row) { return row.name; },
            sortable: true,
        },
        {
            name: 'Active',
            selector: function (row) { return row.active || "false"; },
            cell: function (row) { return _jsx(ActiveSelect, { row: row }); },
            sortable: true,
            width: '90px',
        },
        {
            name: 'URL',
            selector: function (row) { return (accountType === "consumer" ? (row === null || row === void 0 ? void 0 : row.launchEndpoint) || "" : row.url); },
            sortable: true,
        }
    ];
    var customStyles = {
        header: {
            style: {
                minHeight: '56px',
            },
        },
        headRow: {
            style: {
                borderTopStyle: 'solid',
                borderTopWidth: '1px',
                borderTopColor: defaultThemes.default.divider.default,
            },
        },
        headCells: {
            style: {
                borderRightStyle: 'solid',
                borderRightWidth: '1px',
                borderRightColor: defaultThemes.default.divider.default,
                '&:first-of-type': {
                    borderLeftStyle: 'solid',
                    borderLeftWidth: '1px',
                    borderLeftColor: defaultThemes.default.divider.default,
                },
            },
        },
        cells: {
            style: {
                borderRightStyle: 'solid',
                borderRightWidth: '1px',
                borderRightColor: defaultThemes.default.divider.default,
                '&:first-of-type': {
                    borderLeftStyle: 'solid',
                    borderLeftWidth: '1px',
                    borderLeftColor: defaultThemes.default.divider.default,
                },
            },
        },
    };
    var changeActivation = function (row) { return __awaiter(void 0, void 0, void 0, function () {
        var onCall, functionName, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setSaving(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    onCall = CloudFunctions.httpsCallable('oncall');
                    functionName = "";
                    if (accountType === "consumer") {
                        functionName = "updateToolRegistration";
                    }
                    else {
                        functionName = "updateRegistration";
                    }
                    return [4 /*yield*/, onCall({
                            name: functionName,
                            data: {
                                accountId: userData.currentAccount.id,
                                id: row.id,
                                activate: row.active ? "deactivate" : "activate"
                            }
                        })];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 4];
                case 3:
                    err_1 = _a.sent();
                    //@ts-ignore
                    setErrorMessage(err_1.message);
                    return [3 /*break*/, 4];
                case 4:
                    setSaving(false);
                    fetchSettings(userData.currentAccount.id);
                    return [2 /*return*/];
            }
        });
    }); };
    var deleteRegistration = function () { return __awaiter(void 0, void 0, void 0, function () {
        var res, deleteRegistration_1, err_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setSaving(true);
                    setDeleteDialog({ visible: false, row: deleteDialog.row });
                    setShowDeleteButton(false);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 6, , 7]);
                    res = undefined;
                    deleteRegistration_1 = CloudFunctions.httpsCallable('oncall');
                    if (!(accountType === "consumer" && deleteDialog.row !== undefined)) return [3 /*break*/, 3];
                    return [4 /*yield*/, deleteRegistration_1({
                            name: "deleteToolRegistration",
                            data: {
                                accountId: userData.currentAccount.id,
                                toolId: deleteDialog.row.id
                            }
                        })];
                case 2:
                    res = _a.sent();
                    return [3 /*break*/, 5];
                case 3:
                    if (!(deleteDialog.row !== undefined)) return [3 /*break*/, 5];
                    return [4 /*yield*/, deleteRegistration_1({
                            name: "deletePlatformRegistration",
                            data: {
                                accountId: userData.currentAccount.id,
                                platformId: deleteDialog.row.id
                            }
                        })];
                case 4:
                    res = _a.sent();
                    _a.label = 5;
                case 5:
                    if (res !== undefined && res.data.hasOwnProperty('error')) {
                        setErrorMessage(JSON.stringify(res.data, null, 2));
                    }
                    else if (deleteDialog.row !== undefined) {
                        setSuccessMessage("Id ".concat(deleteDialog.row.id, " deleted successfully"));
                    }
                    return [3 /*break*/, 7];
                case 6:
                    err_2 = _a.sent();
                    //@ts-ignore
                    setErrorMessage(err_2.message);
                    return [3 /*break*/, 7];
                case 7:
                    setDeleteDialog({ visible: false, row: undefined });
                    setSaving(false);
                    fetchSettings(userData.currentAccount.id);
                    return [2 /*return*/];
            }
        });
    }); };
    var fetchSettings = useCallback(function (accountId) { return __awaiter(void 0, void 0, void 0, function () {
        var account_type, accountDoc, account_doc, planPromises, plans, doc, api_settings, getRegistrations, functionName;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    account_type = accountType;
                    return [4 /*yield*/, FirebaseAuth.firestore().collection("accounts").doc(accountId).get()];
                case 1:
                    accountDoc = _a.sent();
                    if (!accountDoc.exists) return [3 /*break*/, 3];
                    account_doc = accountDoc.data();
                    if (account_doc === undefined) {
                        return [2 /*return*/];
                    }
                    account_type = account_doc.type;
                    setAccountType(account_type);
                    setAccountFirebase(account_doc.firebase);
                    if (!account_doc.hasOwnProperty("plans")) return [3 /*break*/, 3];
                    planPromises = account_doc.plans.map(function (plan) {
                        return plan.get();
                    });
                    return [4 /*yield*/, Promise.all(planPromises)];
                case 2:
                    plans = _a.sent();
                    plans.forEach(function (plan) {
                        if (plan.data().name.includes("Dynamic Registration")) {
                            setHasDynamicRegistration(true);
                        }
                    });
                    _a.label = 3;
                case 3: return [4 /*yield*/, FirebaseAuth.firestore().collection("subdomains").doc(accountId).get()];
                case 4:
                    doc = _a.sent();
                    if (doc.exists) {
                        api_settings = doc.data();
                        if (api_settings !== undefined && api_settings.hasOwnProperty("subdomainName")) {
                            // subdomain exists
                            setSubdomain(api_settings.subdomainName);
                            getRegistrations = CloudFunctions.httpsCallable('oncall');
                            functionName = "";
                            if (account_type === "consumer") {
                                functionName = "getToolRegistrations";
                            }
                            else {
                                functionName = "getRegistrations";
                            }
                            getRegistrations({
                                name: functionName,
                                data: {
                                    accountId: userData.currentAccount.id
                                }
                            }).then(function (res) {
                                var registrationsData = [];
                                if (res.data.platforms && Array.isArray(res.data.platforms)) {
                                    registrationsData = res.data.platforms;
                                }
                                else if (Array.isArray(res.data)) {
                                    registrationsData = res.data;
                                }
                                setRegistrations(registrationsData);
                                setSettingsComplete(true);
                                setLoading(false);
                            }).catch(function (err) {
                                setErrorMessage(err.message);
                                setRegistrations([]);
                                setSettingsComplete(true);
                                setLoading(false);
                            });
                        }
                        else {
                            setRegistrations([]);
                            setSettingsComplete(false);
                            setLoading(false);
                        }
                    }
                    else {
                        setRegistrations([]);
                        setSettingsComplete(false);
                        setLoading(false);
                    }
                    return [2 /*return*/];
            }
        });
    }); }, [accountType, userData.currentAccount.id]);
    useEffect(function () {
        fetchSettings(userData.currentAccount.id);
        setBreadcrumb([
            {
                to: "/",
                text: "Home",
                active: false,
            },
            {
                to: "/account/" + userData.currentAccount.id + "/",
                text: userData.currentAccount.name + " (".concat(userData.currentAccount.id, ")"),
                active: false,
            },
            {
                to: null,
                text: title,
                active: true,
            },
        ]);
    }, [userData, setBreadcrumb, title, fetchSettings]);
    // Add search state for name and URL
    var _0 = useState({
        hasError: false,
        error: null,
        value: "",
    }), searchTerm = _0[0], setSearchTerm = _0[1];
    // Filter registrations by name or URL
    var filteredRegistrations = ((_a = (Array.isArray(registrations) ? registrations : [])) === null || _a === void 0 ? void 0 : _a.filter(function (item) {
        var _a, _b;
        if (searchTerm.value.length > 1) {
            if ((_a = item.name) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes(searchTerm.value.toLowerCase())) {
                return true;
            }
            if ((_b = item.id) === null || _b === void 0 ? void 0 : _b.toLowerCase().includes(searchTerm.value.toLowerCase())) {
                return true;
            }
            // For consumer, use launchEndpoint, else use url
            var urlField = accountType === "consumer" ? item.launchEndpoint || "" : item.url || "";
            return urlField.toLowerCase().includes(searchTerm.value.toLowerCase());
        }
        else {
            return true;
        }
    })) || [];
    return (_jsx(_Fragment, { children: loading ? (_jsx(PublicTemplate, { children: _jsx(Loader, { size: "5x", text: "Loading..." }) })) : (_jsxs(_Fragment, { children: [_jsxs(Modal, { show: registrationURLsVisible, onHide: function () {
                        setRegistrationURLsVisible(false);
                    }, backdrop: "static", keyboard: false, dialogClassName: "modal-90w", children: [_jsx(Modal.Header, { closeButton: true, children: _jsx(Modal.Title, { children: "Registration URLs" }) }), _jsxs(Modal.Body, { children: [accountType === "provider" &&
                                    _jsxs(_Fragment, { children: [_jsx("h3", { children: "How To Register" }), _jsxs("p", { children: ["Use the URLs below to start the registration process with the LMS. Our ", _jsx("a", { style: { textDecoration: "underline" }, target: "blank", href: "https://ltiaas.com/guides/lms/introduction", children: "LMS Guides" }), " can help you understand how to start this process for all of the major LMSes."] }), hasDynamicRegistration &&
                                                _jsxs(_Fragment, { children: [_jsx("h4", { children: "Dynamic Registration" }), _jsx("p", { children: "Use this URL for dynamic registration if the LMS supports it." }), _jsxs("table", { className: "table", children: [_jsxs("tr", { children: [_jsx("th", { children: "Name" }), _jsx("th", { children: "Value" })] }), _jsxs("tr", { children: [_jsx("td", { children: "Dynamic Registration URL" }), _jsxs("td", { children: [_jsx(CopyableElement, { value: "https://".concat(subdomain, "/") + (accountFirebase ? "lti/register" : "register") }), " "] })] })] })] }), _jsx("h4", { children: "Manual Registration" }), _jsxs("p", { children: [hasDynamicRegistration ? "Otherwise, send " : "Send ", " these URLs to the LMS administrator when they are installing your tool with a manual installation method."] }), _jsxs("table", { className: "table", children: [_jsxs("tr", { children: [_jsx("th", { children: "Name" }), _jsx("th", { children: "Value" })] }), _jsxs("tr", { children: [_jsx("td", { children: "URL (or Redirection URI(s))" }), _jsxs("td", { children: [_jsx(CopyableElement, { value: "https://".concat(subdomain, "/") + (accountFirebase ? "lti/launch" : "") }), " "] })] }), _jsxs("tr", { children: [_jsx("td", { children: "Target Link URI" }), _jsxs("td", { children: [_jsx(CopyableElement, { value: "https://".concat(subdomain, "/") + (accountFirebase ? "lti/launch" : "") }), " "] })] }), _jsxs("tr", { children: [_jsx("td", { children: "Initiate login URL (or OpenID Connect Initiation Url)" }), _jsx("td", { children: _jsx(CopyableElement, { value: "https://".concat(subdomain, "/") + (accountFirebase ? "lti/login" : "login") }) })] }), _jsxs("tr", { children: [_jsx("td", { children: "Authentication Method" }), _jsx("td", { children: "JWK Set (or Public JWK URL)" })] }), _jsxs("tr", { children: [_jsx("td", { children: "Public Keyset (or Public JWK URL)" }), _jsx("td", { children: _jsx(CopyableElement, { value: "https://".concat(subdomain, "/") + (accountFirebase ? "lti/keys" : "keys") }) })] })] })] }), accountType === "consumer" &&
                                    _jsxs(_Fragment, { children: [_jsx("p", { children: "Send these URLs to the LTI Tool owner when they are installing their tool into your Consumer." }), _jsxs("table", { className: "table", children: [_jsxs("tr", { children: [_jsx("th", { children: "Name" }), _jsx("th", { children: "Value" })] }), _jsxs("tr", { children: [_jsx("td", { children: "URL" }), _jsx("td", { children: _jsx(CopyableElement, { value: "https://".concat(subdomain) }) })] }), _jsxs("tr", { children: [_jsx("td", { children: "Authentication Endpoint" }), _jsxs("td", { children: [_jsx(CopyableElement, { value: "https://".concat(subdomain, "/lti/authenticate") }), " "] })] }), _jsxs("tr", { children: [_jsx("td", { children: "Accesstoken Endpoint" }), _jsx("td", { children: _jsx(CopyableElement, { value: "https://".concat(subdomain, "/lti/authorize") }) })] }), _jsxs("tr", { children: [_jsx("td", { children: "Authorization Server" }), _jsx("td", { children: _jsx(CopyableElement, { value: "https://".concat(subdomain, "/lti/authorize") }) })] }), _jsxs("tr", { children: [_jsx("td", { children: "Authentication Method" }), _jsx("td", { children: "JWK Set (or Public JWK URL)" })] }), _jsxs("tr", { children: [_jsx("td", { children: "Public Keyset (or Public JWK URL)" }), _jsx("td", { children: _jsx(CopyableElement, { value: "https://".concat(subdomain, "/lti/keys") }) })] })] })] })] })] }), _jsxs(Modal, { show: registrationFormVisible, onHide: function () {
                        fetchSettings(userData.currentAccount.id);
                        setRegistrationFormVisible(false);
                    }, backdrop: "static", keyboard: false, dialogClassName: "modal-90w", children: [_jsx(Modal.Header, { closeButton: true, children: _jsx(Modal.Title, { children: registrationTitle }) }), _jsx(Modal.Body, { children: accountType === "provider" ?
                                _jsx(EditRegistration, { data: deleteDialog.row })
                                :
                                    _jsx(EditRegistrationConsumer, { data: deleteDialog.row }) })] }), _jsxs(Modal, { show: deleteDialog.visible, onHide: function () {
                        fetchSettings(userData.currentAccount.id);
                        setDeleteDialog({ visible: false, row: undefined });
                    }, children: [_jsx(Modal.Header, { closeButton: true, children: _jsx(Modal.Title, { children: "Edit Registration" }) }), _jsxs(Modal.Body, { children: ["Choose an action below for this registration?", _jsx("div", { children: _jsx(Highlight, { className: 'language-json', children: registrationInfo }) }), showDeleteButton && (_jsxs(_Fragment, { children: [_jsx("div", { children: _jsx("b", { children: "Are you sure you want to delete?" }) }), _jsx("button", { type: "button", className: "btn btn-danger", onClick: function (e) {
                                                e.preventDefault();
                                                deleteRegistration();
                                            }, children: "Confirm Delete" })] }))] }), _jsxs(Modal.Footer, { children: [_jsx("button", { type: "button", className: "btn btn-danger", onClick: function (e) {
                                        e.preventDefault();
                                        setShowDeleteButton(!showDeleteButton);
                                    }, children: "Delete" }), _jsx("button", { type: "button", className: "btn btn-secondary", onClick: function (e) {
                                        e.preventDefault();
                                        setDeleteDialog({ visible: false, row: undefined });
                                    }, children: "Cancel" }), _jsx("button", { type: "button", className: "btn btn-info", onClick: function (e) {
                                        e.preventDefault();
                                        if (deleteDialog.row === undefined) {
                                            return;
                                        }
                                        setRegistrationTitle("Editing Registration: ".concat(deleteDialog.row.id));
                                        setDeleteDialog({ visible: false, row: deleteDialog.row });
                                        setRegistrationFormVisible(true);
                                        setShowDeleteButton(false);
                                    }, children: "Edit" })] })] }), _jsxs(Modal, { show: showChangeActivationDialog.visible, onHide: function () {
                        setShowChangeActivationDialog({ visible: false, row: undefined });
                    }, children: [_jsx(Modal.Header, { closeButton: true, children: _jsx(Modal.Title, { children: "Edit Activation" }) }), _jsxs(Modal.Body, { children: ["Are you sure you want to ", ((_b = showChangeActivationDialog.row) === null || _b === void 0 ? void 0 : _b.active) === "true" ? "DEACTIVATE" : "ACTIVATE", " the '", (_c = showChangeActivationDialog.row) === null || _c === void 0 ? void 0 : _c.name, "' registration?"] }), _jsxs(Modal.Footer, { children: [_jsx(Button, { variant: ((_d = showChangeActivationDialog.row) === null || _d === void 0 ? void 0 : _d.active) ? "danger" : "success", onClick: function (e) {
                                        e.preventDefault();
                                        changeActivation(showChangeActivationDialog.row);
                                        setShowChangeActivationDialog({ visible: false, row: undefined });
                                    }, children: ((_e = showChangeActivationDialog.row) === null || _e === void 0 ? void 0 : _e.active) ? "Deactivate" : "Activate" }), _jsx("button", { type: "button", className: "btn btn-secondary", onClick: function (e) {
                                        e.preventDefault();
                                        setShowChangeActivationDialog({ visible: false, row: undefined });
                                    }, children: "Cancel" })] })] }), _jsx("div", { className: "container-fluid", children: _jsxs("div", { className: "animated fadeIn", children: [_jsx(AccountSteps, { accountSettingsComplete: settingsComplete || false, subscriptionStatus: userData.currentAccount.subscriptionStatus, numRegistrations: (registrations === null || registrations === void 0 ? void 0 : registrations.length) || null, onAPISettingsPage: false, onRegistrationsPage: true, hidden: !guide }), errorMessage !== null && (_jsx(Alert, { type: "danger", message: errorMessage, dismissible: true, onDismiss: function () { return setErrorMessage(null); } })), saving && (_jsx(Alert, { type: "warning", message: "Saving...", dismissible: false })), helpMessage !== null && (_jsx(Alert, { type: "info", message: "This page displays the current registrations that your API has. Once a registration has been completed (either manually or through dynamic registration) you will see it here. The true/false buttons in the 'Active' column can be used to activate/deactivate any registration.", dismissible: true, onDismiss: function () { return setHelpMessage(null); } })), successMessage !== null && (_jsx(Alert, { type: "info", message: successMessage, dismissible: true, onDismiss: function () { return setSuccessMessage(null); } })), !settingsComplete && registrations && (_jsxs("div", { className: "card", children: [_jsx("div", { className: "card-header", children: "Finish your API setup" }), _jsx("div", { className: "card-body", children: _jsxs("p", { children: ["Before you API can go live, you need to set your API settings. Please edit your \u00A0", _jsx("b", { children: _jsx(Link, { to: "/account/" + userData.currentAccount.id + "/settings", children: "API Settings" }) }), "."] }) })] })), _jsxs("div", { className: "card", children: [_jsxs("div", { className: "card-header", children: [_jsx("h3", { style: { float: "left" }, children: title }), _jsx("button", { style: { float: "right", marginBottom: "0.5rem" }, type: "button", className: "btn btn-success", onClick: function (e) {
                                                    e.preventDefault();
                                                    if (accountType === "consumer") {
                                                        setRegistrationTitle('Register Tool');
                                                    }
                                                    else {
                                                        setRegistrationTitle('Register Platform');
                                                    }
                                                    setDeleteDialog({ visible: false, row: undefined });
                                                    setRegistrationFormVisible(true);
                                                }, children: "+ Add Registration" }), subdomain !== null &&
                                                _jsx("button", { style: { marginRight: "1rem", marginBottom: "0.5rem", float: "right" }, type: "button", className: "btn btn-primary", onClick: function (e) {
                                                        e.preventDefault();
                                                        setRegistrationURLsVisible(true);
                                                    }, children: "Display Registration URLs" }), _jsxs("div", { style: {
                                                    display: "flex",
                                                    justifyContent: "flex-end",
                                                    alignItems: "center",
                                                    gap: "0.5rem",
                                                    padding: "0 1rem",
                                                    borderRadius: "0.5rem",
                                                    minWidth: "20rem",
                                                    marginLeft: "auto",
                                                    marginBottom: "0.5rem",
                                                    marginRight: "0",
                                                }, children: [_jsx("i", { className: "fa fa-search", style: { color: "#888", fontSize: "1.2rem" } }), _jsx(Input, { type: "text", value: searchTerm.value, placeholder: "Search registrations by name, id, or URL...", name: "searchTerm", required: false, changeHandler: setSearchTerm, style: {
                                                            border: "1px solid #ced4da",
                                                            borderRadius: "0.3rem",
                                                            width: "100%",
                                                            background: "#fff",
                                                        } })] })] }), _jsxs("div", { className: "card-body", children: [!userData.currentAccount.subscriptionStatus && (_jsxs("p", { children: ["Account status is not active,", " ", _jsx("b", { children: _jsx(Link, { to: "/account/" + userData.currentAccount.id + "/plan", children: "activate a plan here to continue" }) }), "."] })), registrations &&
                                                _jsx(DataTable, { data: filteredRegistrations, columns: columns, pagination: true, 
                                                    // @ts-ignore
                                                    customStyles: customStyles })] })] })] }) })] })) }));
};
export default Registrations;
